var _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 -1.5 1027 1027",
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.273865 685.070423h931.856025v302.071987c0 12.018779-9.615023 20.832551-20.83255 20.832551H68.907668c-12.018779 0-20.832551-9.615023-20.832551-20.832551l-0.801252-302.071987z",
    fill: "#B08A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.29734 1024H68.106416c-20.832551 0-36.85759-16.826291-36.85759-36.85759V669.045383h963.906104v318.097027c0.801252 20.832551-16.025039 36.85759-36.85759 36.85759zM63.298905 701.095462v286.046948c0 3.205008 2.403756 4.807512 4.807511 4.807512h890.190924c3.205008 0 4.807512-2.403756 4.807511-4.807512V701.095462H63.298905z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.460094 241.978091h949.483568c12.820031 0 22.435055 10.416275 22.435055 22.435055v398.222222c0 12.820031-10.416275 22.435055-22.435055 22.435055H38.460094c-12.820031 0-22.435055-10.416275-22.435055-22.435055V264.413146c0-12.820031 10.416275-22.435055 22.435055-22.435055z",
    fill: "#B08A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M987.943662 701.095462H38.460094c-21.633803 0-38.460094-17.627543-38.460094-38.460094V264.413146c0-21.633803 17.627543-38.460094 38.460094-38.460094h949.483568c21.633803 0 38.460094 17.627543 38.460094 38.460094v398.222222c0.801252 20.832551-16.826291 38.460094-38.460094 38.460094zM38.460094 258.00313c-3.205008 0-6.410016 2.403756-6.410016 6.410016v398.222222c0 4.00626 3.205008 6.410016 6.410016 6.410015h949.483568c4.00626 0 6.410016-3.205008 6.410016-6.410015V264.413146c0-4.00626-3.205008-6.410016-6.410016-6.410016H38.460094z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.935837 16.025039h341.333334c12.018779 0 21.633803 9.615023 21.633802 21.633803v204.319249h-384.600939V37.658842c0-12.018779 9.615023-21.633803 21.633803-21.633803z",
    fill: "#B08A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M721.928013 258.00313h-416.651018V37.658842c0-20.832551 16.826291-37.658842 37.658842-37.658842h341.333334c20.832551 0 37.658842 16.826291 37.658842 37.658842v220.344288z m-384.600939-32.050078h352.55086V37.658842c0-3.205008-2.403756-5.608764-5.608763-5.608764H342.935837c-3.205008 0-5.608764 2.403756-5.608763 5.608764v188.29421z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.600939 74.516432h258.00313v166.660407H384.600939z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M658.629108 258.00313H368.5759V58.491393h290.053208v199.511737z m-258.00313-32.050078h225.953052V90.541471H400.625978v135.411581zM933.458529 320.500782H86.535211c-8.813772 0-16.025039-7.211268-16.025039-16.025039s7.211268-16.025039 16.025039-16.025039h846.923318c8.813772 0 16.025039 7.211268 16.025039 16.025039s-7.211268 16.025039-16.025039 16.025039z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.175274 964.707355c-8.813772 0-16.025039-7.211268-16.025039-16.025039V685.070423c0-8.813772 7.211268-16.025039 16.025039-16.02504s16.025039 7.211268 16.025039 16.02504v263.611893c0 8.813772-7.211268 16.025039-16.025039 16.025039z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M911.824726 964.707355c-8.813772 0-16.025039-7.211268-16.025039-16.025039V685.070423c0-8.813772 7.211268-16.025039 16.025039-16.02504s16.025039 7.211268 16.025039 16.02504v263.611893c0 8.813772-7.211268 16.025039-16.025039 16.025039z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.651017 609.752739h192.30047v155.442879H416.651017z",
    fill: "#FFFFFFFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.976526 781.220657H400.625978V593.7277h224.350548v187.492957z m-192.30047-32.050078h160.250392V625.777778H432.676056v123.392801z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M486.359937 670.647887h52.88263v35.255086h-52.88263z",
    fill: "#191919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.267606 721.928013H470.334898v-67.305165h84.932708v67.305165z m-52.882629-32.050079h20.83255v-3.205008h-20.83255v3.205008z",
    fill: "#191919"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.1dafde9f550d83d31963f8c1367a85a7.svg";
export { ForwardRef as ReactComponent };